import React from 'react';
import { FooterStyled } from './styles.js';

function Footer() {
  return (
    <FooterStyled>
        <p>© Todos os Diretos Reservados - Mariana Saraiva </p>
    </FooterStyled>
  );
}

export default Footer;